export default __webpack_public_path__ + "static/media/meta-mask.c1971bf3.svg";